export default __webpack_public_path__ + "static/media/computing.bb2a97aa.svg";